import type { FigmaRestApi } from "@zeytal/types";

import { addQueryParams, getFigmaEndpoint } from "../utils/index.ts";

export const getFigmaImagesEndpoint = async (
  figmaApiKey: string,
  figmaFileId: string,
  queryParams = "",
) => {
  const endpoint = `https://api.figma.com/v1/images/${figmaFileId}`;
  return getFigmaEndpoint<FigmaRestApi.GetImagesResponse>(
    figmaApiKey,
    addQueryParams(endpoint, queryParams),
  );
};
